import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { PollResponse, } from '../../helpers/proto/plugnmeet_polls_pb';
export const pollsApi = createApi({
    reducerPath: 'pollsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: window.PLUG_N_MEET_SERVER_URL + '/api/polls',
        prepareHeaders: (headers, api) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const token = api.getState().session.token;
            headers.append('Authorization', token);
            headers.append('Content-Type', 'application/json');
            return headers;
        },
    }),
    tagTypes: [
        'List',
        'PollsStats',
        'Count',
        'Selected',
        'PollDetails',
        'PollResult',
    ],
    endpoints: (builder) => ({
        getPollLists: builder.query({
            query: () => {
                return {
                    url: 'listPolls',
                    responseHandler: async (res) => {
                        const buf = await res.arrayBuffer();
                        return PollResponse.fromBinary(new Uint8Array(buf)).toJson();
                    },
                };
            },
            providesTags: ['List'],
        }),
        getCountTotalResponses: builder.query({
            query: (poll_id) => {
                return {
                    url: `countTotalResponses/${poll_id}`,
                    responseHandler: async (res) => {
                        const buf = await res.arrayBuffer();
                        return PollResponse.fromBinary(new Uint8Array(buf)).toJson();
                    },
                };
            },
            providesTags: (result) => {
                return (result === null || result === void 0 ? void 0 : result.status)
                    ? ['Count', { type: 'Count', id: result === null || result === void 0 ? void 0 : result.pollId }]
                    : ['Count'];
            },
        }),
        getUserSelectedOption: builder.query({
            query: ({ pollId, userId }) => {
                return {
                    url: `userSelectedOption/${pollId}/${userId}`,
                    responseHandler: async (res) => {
                        const buf = await res.arrayBuffer();
                        return PollResponse.fromBinary(new Uint8Array(buf)).toJson();
                    },
                };
            },
            providesTags: (result) => {
                return (result === null || result === void 0 ? void 0 : result.status)
                    ? ['Selected', { type: 'Selected', id: result.pollId }]
                    : ['Selected'];
            },
        }),
        getPollResponsesDetails: builder.query({
            query: (poll_id) => {
                return {
                    url: `pollResponsesDetails/${poll_id}`,
                    responseHandler: async (res) => {
                        const buf = await res.arrayBuffer();
                        return PollResponse.fromBinary(new Uint8Array(buf)).toJson();
                    },
                };
            },
            providesTags: (result) => {
                return (result === null || result === void 0 ? void 0 : result.status)
                    ? ['PollDetails', { type: 'PollDetails', id: result.pollId }]
                    : ['PollDetails'];
            },
        }),
        getPollResponsesResult: builder.query({
            query: (poll_id) => {
                return {
                    url: `pollResponsesResult/${poll_id}`,
                    responseHandler: async (res) => {
                        const buf = await res.arrayBuffer();
                        return PollResponse.fromBinary(new Uint8Array(buf)).toJson();
                    },
                };
            },
            providesTags: (result) => {
                return (result === null || result === void 0 ? void 0 : result.status)
                    ? ['PollResult', { type: 'PollResult', id: result.pollId }]
                    : ['PollResult'];
            },
        }),
        getPollsStats: builder.query({
            query: () => {
                return {
                    url: 'pollsStats',
                    responseHandler: async (res) => {
                        const buf = await res.arrayBuffer();
                        return PollResponse.fromBinary(new Uint8Array(buf)).toJson();
                    },
                };
            },
            providesTags: ['PollsStats'],
        }),
        createPoll: builder.mutation({
            query(body) {
                return {
                    url: 'create',
                    method: 'POST',
                    body: body.toBinary(),
                    responseHandler: async (res) => {
                        const buf = await res.arrayBuffer();
                        return PollResponse.fromBinary(new Uint8Array(buf)).toJson();
                    },
                };
            },
            invalidatesTags: ['List', 'PollsStats'],
        }),
        addResponse: builder.mutation({
            query(body) {
                return {
                    url: 'submitResponse',
                    method: 'POST',
                    body: body.toBinary(),
                    responseHandler: async (res) => {
                        const buf = await res.arrayBuffer();
                        return PollResponse.fromBinary(new Uint8Array(buf)).toJson();
                    },
                };
            },
            invalidatesTags: (result, error, { pollId }) => [
                { type: 'Count', id: pollId },
                { type: 'Selected', id: pollId },
                { type: 'PollDetails', id: pollId },
            ],
        }),
        closePoll: builder.mutation({
            query(body) {
                return {
                    url: 'closePoll',
                    method: 'POST',
                    body: body.toBinary(),
                    responseHandler: async (res) => {
                        const buf = await res.arrayBuffer();
                        return PollResponse.fromBinary(new Uint8Array(buf)).toJson();
                    },
                };
            },
            invalidatesTags: ['List', 'PollsStats'],
        }),
    }),
});
export const { useGetPollListsQuery, useGetCountTotalResponsesQuery, useGetUserSelectedOptionQuery, useGetPollResponsesDetailsQuery, useCreatePollMutation, useAddResponseMutation, useClosePollMutation, useGetPollResponsesResultQuery, useGetPollsStatsQuery, } = pollsApi;
